/* eslint-disable import/no-cycle */
import { call, takeEvery, put } from 'redux-saga/effects';
import {
  UPDATE_USER,
  ADD_COLLABORATOR,
  CREATE_ADDRESS,
  CREATE_ADDRESS_SUCCESS,
  GET_ADDRESS,
  GET_ADDRESS_SUCCESS,
  GET_ADDRESS_FAILURE,
  DELETE_ADDRESS,
  DELETE_ADDRESS_SUCCESS
} from './userProfileActions';

import { user, address } from '../../api/api';
import logger from '../../utils/logger';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';

export function* updateUser(action) {
  const closeLoading = displayLoading('Mise à jour des informations en cours');
  try {
    const response = yield call(user.update, action.payload);
    if (response.data.success === true) {
      displaySuccess('Mise à jour des informations effectuées');
      yield put({ type: 'RESET_SIGNIN_REDUCER' });
    }
  } catch (error) {
    logger(error);
  } finally {
    closeLoading();
  }
}

export function* addCollaborator(action) {
  const closeLoading = displayLoading('Ajout de votre collaborateur en cours');
  try {
    const response = yield call(user.addCollaborator, action.payload);
    if (response.data.success === true) {
      displaySuccess(
        `${action.payload.firstname}
         ${action.payload.lastname}
         a été ajouté comme collaborateur`
      );
    }
  } catch (error) {
    logger(error);
  } finally {
    closeLoading();
  }
}

export function* getAddress() {
  try {
    const response = yield call(address.getAddress);
    if (response.data.success === true) {
      yield put({
        type: GET_ADDRESS_SUCCESS,
        payload: response.data.addresses
      });
    } else {
      yield put({ type: GET_ADDRESS_FAILURE });
    }
  } catch (error) {
    logger(error);
  }
}

export function* createAddress(action) {
  const closeLoading = displayLoading('Ajout de votre adresse en cours');
  try {
    const response = yield call(address.create, action.payload);
    yield put({ type: CREATE_ADDRESS_SUCCESS });
    if (response.data.success === true) {
      displaySuccess(
        `L'adresse ${action.payload.label}
         a été ajouté avec succès`
      );
    }
  } catch (error) {
    logger(error);
  } finally {
    closeLoading();
  }
}

export function* deleteAddress(action) {
  const closeLoading = displayLoading('Suppression de votre adresse en cours');
  try {
    const response = yield call(address.delete, action.payload);
    if (response.data.success === true) {
      yield put({ type: DELETE_ADDRESS_SUCCESS });
      displaySuccess(`Adresse supprimée avec succès`);
    }
  } catch (error) {
    logger(error);
  } finally {
    closeLoading();
  }
}

const signinSaga = [
  takeEvery(UPDATE_USER, updateUser),
  takeEvery(ADD_COLLABORATOR, addCollaborator),
  takeEvery(GET_ADDRESS, getAddress),
  takeEvery(CREATE_ADDRESS, createAddress),
  takeEvery(DELETE_ADDRESS, deleteAddress)
];

export default signinSaga;
